export default function queryly() {
  return `<script type="text/javascript" src="//www.queryly.com/js/queryly.v4.js"></script><script type="text/javascript" async src="//www.queryly.com/js/fastcompany-advanced-search.js"></script>`;
}
